<template>
    <div class="relative" v-click-outside="closeMenu">
        <div class="cursor-pointer" @click="menuHandler">
            <NotificationIcon class="fill-purple dark:fill-white transition-colors" />

            <div class="flex justify-center items-center h-3 w-3 absolute -top-1 -right-1" v-if="show">
                <div class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red opacity-75"></div>
                <div class="relative inline-flex rounded-full h-2 w-2 bg-red"></div>
            </div>
        </div>


        <div
            class="w-121 max-h-screen-80 overflow-y-auto absolute -right-20 top-offset-full-4 divide-y divide-purple-50 bg-purple-200 rounded-lg transition-all duration-300 ease-in z-10 scrollbar-thin scrollbar-thumb-blue dark:scrollbar-thumb-purple-400"
            :class="{ 'hidden': !menu }"
        >
            <div
                v-if="notifications.length"
                class="px-4 py-3 text-white"
                v-for="(notification, index) in notifications"
                :key="index"
            >
                <div class="notification" v-html="notification"></div>
            </div>

            <div class="px-4 py-3 text-white" v-else>No notifications</div>
        </div>
    </div>
</template>

<script>
import NotificationIcon from '@/components/icons/NotificationIcon'

import { getNotificationsCounter, getNotifications } from '@/api/notification-routes'

export default {
    name: 'NotificationMenu',
    components: { NotificationIcon },
    data: () => ({
        notifications: [],
        show: false,
        menu: false,
        notificationsInterval: null,
    }),
    mounted() {
        this.loadNotificationsCounter()
        this.setNotificationsInterval()
    },
    methods: {
        setNotificationsInterval() {
            clearInterval(this.notificationsInterval)

            this.notificationsInterval = setInterval(() => {
                this.loadNotificationsCounter()

                if (!!this.menu) {
                    this.loadNotifications()
                }
            }, 30000)
        },
        async loadNotificationsCounter() {
            const { success, payload } = await getNotificationsCounter()

            if (success) {
                this.show = !!payload
            }
        },
        async loadNotifications() {
            const { success, payload, message } = await getNotifications()

            if (success) {
                this.notifications = payload
            } else {
                !!message && this.$notify({ type: 'error-bg', duration: 15000, text: message })
            }
        },
        menuHandler() {
            this.menu = !this.menu
        },
        closeMenu() {
            this.menu = false
        },
    },
    watch: {
        menu: {
            handler(menu) {
                if (menu) {
                    this.loadNotifications()
                } else {
                    this.loadNotificationsCounter()
                    this.setNotificationsInterval()
                }
            }
        },
    },
    beforeUnmount() {
        clearInterval(this.notificationsInterval)
    },
}
</script>
